import { useFormatter, WithSkeleton } from '@capsicum/common';
import { Text } from '@capsicum/common-web';
import styled from 'styled-components';

import { WCPledgeUserPledgeItemSkeleton } from './WCPledgeUserPledgeItem';

export type WCPledgeListTotalFooterItemProps = {
	chzAmount: string;
	fiatAmount: string;
	testID: string;
	titleText: string;
};

export const WCPledgeListTotalFooterItemComponent = ({
	chzAmount,
	fiatAmount,
	testID,
	titleText
}: WCPledgeListTotalFooterItemProps) => {
	const { formatCrypto } = useFormatter();

	return (
		<S.PledgeListFooter>
			<S.PledgeFooterLabel>
				<Text variant="text2">{titleText}</Text>
			</S.PledgeFooterLabel>

			<S.PledgeFooterAmount>
				<Text testID={`${testID}-chz`} variant="text1">
					{`${formatCrypto(chzAmount, 'CHZ')}`}
				</Text>

				<Text testID={`${testID}-fiat`} variant="caption2">
					{`≈${formatCrypto(fiatAmount, 'USD')}`}
				</Text>
			</S.PledgeFooterAmount>
		</S.PledgeListFooter>
	);
};

export const WCPledgeListTotalFooterItem = WithSkeleton(
	WCPledgeListTotalFooterItemComponent,
	WCPledgeUserPledgeItemSkeleton
);

export namespace S {
	export const PledgeListFooter = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		border-top: 1px solid ${({ theme }) => theme.colors.borders.main.subtle};
		padding: ${({ theme }) => theme.spacings.small} 0;
		gap: ${({ theme }) => theme.spacings.small};
	`;

	export const PledgeFooterLabel = styled.div`
		display: flex;
		align-items: flex-start;
		gap: ${({ theme }) => theme.spacings.xsmall};
		flex: 1;
	`;
	export const PledgeFooterAmount = styled.div`
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		gap: ${({ theme }) => theme.spacings.xxsmall};
	`;
}
